import React from "react";
import clsx from "clsx";
import { TextField, Autocomplete } from "@mui/material";
import useObjectTypes from "../../hooks/useObjectTypes";

import { getNameFromValue, isSameValue } from "../../utils/form";

export default function ObjectTypeLookup({
  className,
  data,
  formStateHandlers,
  fieldSetting,
  helperText,
  variant,
  required,
  inputProps,
  ...props
}) {
  const [objectTypes] = useObjectTypes();

  const { raw } = formStateHandlers;
  const fieldConfig = raw({
    ...fieldSetting,
    onChange: (input) => {
      const value = input.selectValue;
      fieldSetting.onChange({
        target: {
          value,
        },
      });
      return value;
    },
    validate: (value, _values, event) => {
      // Delibirately checking between event.selectValue and value
      // because when using tab to select an item,
      // 'value' might return undefined.
      return !required || !!event.selectValue || !!value;
    },
  });

  if (!objectTypes) {
    return null;
  }

  const fieldProps = {
    ...fieldConfig,
    ...props,
    onChange: (e, value) => {
      // Re-package value, useFormState does not pass through second arg
      e.selectValue = value ? value.abbr : null;
      return fieldConfig.onChange(e);
    },
    id: `lookup_${fieldConfig.name}`,
    className: clsx(className),
    getOptionSelected: isSameValue,
  };

  const finalInputProps = {
    label: props.label,
    error: props.error,
    variant,
    required,
    helperText,
    ...inputProps,
  };

  return (
    <Autocomplete
      {...fieldProps}
      options={objectTypes}
      getOptionLabel={(value) => getNameFromValue(objectTypes, value)}
      isOptionEqualToValue={(option, value) => isSameValue(option, value)}
      autoSelect={true}
      renderInput={(params) => (
        <TextField
          {...params}
          {...finalInputProps}
          fullWidth
          label={
            finalInputProps.required
              ? `${finalInputProps.label} (required)`
              : finalInputProps.label
          }
          error={data?.isFieldFailed}
          InputLabelProps={{
            // hard coded to true to position label above input
            shrink: true,
            // hard coded to false to prevent an asterisk from showing
            required: false,
          }}
        />
      )}
    />
  );
}
